export default function getRecaptchaResponse(): Promise<string> {
	return new Promise((resolve, reject) => {
		(window as any).recaptchaSuccessCallback = (response: string) => {
			resolve(response);

			grecaptcha.reset();
		};

		(window as any).recaptchaErrorCallback = () => {
			reject();

			grecaptcha.reset();
		};

		try {
			grecaptcha.execute();
		} catch (e) {
			console.log(`An error occured when executing the reCaptcha: ${e}`);

			grecaptcha.reset();

			reject();
		}
	});
}
